// this file added for individual by Bearer Web Developer
export const validateEmail = (value: string) => {
    if (value.length === 0) return "Email address is required";
    if (!(value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))) return 'Email address is not valid!'
}
export const validateFirstName = (value: string) => {
    if (value.length === 0) return "First Name is required";
    else if (!value.match(/^[a-zA-Z]{2,}$/)) return "Minimum 2 Letters, No Numbers or Symbols"
}
export const validateLastName = (value: string) => {
    if (value.length === 0) return "Last Name is required";
    else if (!value.match(/^[a-zA-Z]{2,}$/)) return "Minimum 2 Letters, No Numbers or Symbols"
}
export const validateGender = (value: string) => {
    if (value.length === 0) return "Gender is required";
}
export const validatePlaceName = (value: string) => {
    if (value.length === 0) return "Date of Birth is required";
}

